import gql from 'graphql-tag';

/**
 * @param {String} fieldUUID
 * @returns {Object} Rogue application analytics query
 */
export function getApplicationAnalyticsQuery(fieldUUID) {
  return {
    query: gql`
      query GetApplicationAnalytics(
      $fieldUuid: ID!
      ) {
        field(
        id: $fieldUuid
        ) {
          id
          applicationAnalytics {
            applicationEventAggregates {
              seasonCode
              applicationData {
                passName
                startDateTime
                endDateTime
                localAppliedDate
                machineId
                appliedArea
                averageApplicationRate
                productStats {
                  id
                  name
                  productAppliedDates
                  lastAppliedDate
                  averageProductRate
                  growerInputProductRateUnit
                  totalAmountApplied
                  relativeArea
                  productAppliedArea
                }
              }
            }
          }
        }
      }
    `,
    variables: {
      fieldUuid: fieldUUID,
    },
  };
}